/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';
import { generateUrl } from '../../util';
import { SURVEY } from '@constants/terminology';
import { OnboardingStatus, OnboardingToken } from '@g17eco/types/onboarding';

interface ErrorProps {
  token: Partial<Pick<OnboardingToken, 'status'>>;
  errorMessage?: string;
  reloadOnboarding: () => void;
  setUserMessage: (message?: string) => void;
}

class Error extends React.Component<ErrorProps & RouteComponentProps> {

  componentDidUpdate() {
    document.title = 'G17Eco - Invalid Token';
  }

  render() {
    const { token, errorMessage } = this.props;

    const getTitle = (status?: OnboardingStatus) => {
      switch (status) {
        case OnboardingStatus.Rejected:
        case OnboardingStatus.Deleted:
          return 'This token has expired or is no longer valid';
        default:
          return errorMessage || 'This token is not valid';
      }
    }

    const title = getTitle(token.status);

    return <div className='surveyOnboarding row'>
      <div className='offset-3 col-6'>
        <h1>{title}</h1>
        <p>If you think this is an error, please contact support.</p>

        <Link to={generateUrl(ROUTES.COMPANY_TRACKER)} className='mt-4 btn btn-secondary w-100'>
          Go to {SURVEY.PLURAL}
          </Link>
      </div>
    </div>
  }
}

export default withRouter(Error);
